module.exports = __webpack_public_path__ + "img/other-overheads.3fb92e14.svg";